export default __webpack_public_path__ + "static/media/job_offer18_m.b37a3e58.jpg";